import React from 'react';

import ListTable from '../../ListTable';

import { StyledTableDefault } from './style/StyledTableDefault';

import { renderKeysTable } from '../../../services/reports';

const TableDefault = ({ data, keys }) => (
	<StyledTableDefault className="w-100">
		<div className="content-1200 pt-1">
			<ListTable
				keys={renderKeysTable(keys)}
				actions=""
				elements={data}
			/>
		</div>
	</StyledTableDefault>
);

export default TableDefault;
